var lx = lx || {};

lx.msg = {
    markRead: (pThis) => {
        var id = "";
        if (pThis){
            id = 0;
        }
        lx.msg.handle('READ', null, null, lx.msg.markReadDone);
    },
    markReadDone: (d) => {
        if (d.id){
            $("#conv"+ d.id).addClass("read");//TODO
        }
        lx.topMenu.reduceBadge('M', d.cnt);
    },
    newConversation: (pThis) => {
        null;
        /*apex.navigation.dialog('f?p=' + $v('pFlowId') + ':38:' + $v('pInstance'), {
            title:'New Message',
            height:'650',
            width:'500',
            maxWidth:'960',
            modal:true,
            dialog:null
        },'t-Dialog-page--standard', pThis);*/
    },
    isDeleted: (pId,pSts) => {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "text",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=ARCHIVE_MESSAGE",
                x01: pId,
				x02: pSts
            }
        });
        refresh_ir_report('lxConversation');
    },
    isDeletedDD: (pId,pThis,pConfirmed) => {
		if (!pConfirmed){
			lx.info.confirm(lx.tran.get("MSG_DECLINE_CONFIRM_MSG"), 
							(okPressed)=>{if( okPressed ) {lx.msg.isDeletedDD(pId,pThis,true);}}, 
							{ok:lx.tran.get("YES_SMALL"),cancel:lx.tran.get("NO_SMALL")});
			return;
		}
		
        $.ajax({
            url: "wwv_flow.show",
            dataType: "text",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=ARCHIVE_MESSAGE",
                x01: pId,
				x02: 'A'
            }
        });
        $(pThis).closest(".box").hide();
    },
    handle: (pType, pId, pData, pCallback) => {
        apex.server.process('msgHandle', {
            x01: pType,
            x02: pId,
            x03: pData
        }, {
            type: "POST",
            dataType: "json",
            success: (d) => {
                if (d.error){
                    console.log(d);
                    alert("Something went wrong!");
                } else if (pCallback){
                    pCallback(d);
                }
            },
            error: function( jqXHR, textStatus, errorThrown ) {
                lx.topMenu.fetchInProgress = false;
                console.log( errorThrown );
            }
        });
    },
    pushMessage: function () {
       
        $('#P' + $v('pFlowStepId') + '_MESSAGE').keypress(function (e) {
            if (e.keyCode == 13 && !e.shiftKey && $v('P' + $v('pFlowStepId') + '_USE_ENTER') == 'Y') {
    
                e.preventDefault();
                $.ajax({
                    url: "wwv_flow.show",
                    dataType: "html",
                    traditional: true,
                    cache: false,
                    type: "POST",
                    data: {
                        p_flow_id: $v("pFlowId"),
                        p_flow_step_id: $v("pFlowStepId"),
                        p_instance: $v("pInstance"),
                        p_request: "APPLICATION_PROCESS=PUSH_MESSAGE",
                        x01: $v('P' + $v('pFlowStepId') + '_ID'),
                        x02: $v('P' + $v('pFlowStepId') + '_MESSAGE')
                    }
                })
                $('#P' + $v('pFlowStepId') + '_MESSAGE').val('');
            }
        })
    
        if ($v('P' + $v('pFlowStepId') + '_USE_ENTER') == '') {
            $.ajax({
                url: "wwv_flow.show",
                dataType: "html",
                traditional: true,
                cache: false,
                type: "POST",
                data: {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: "APPLICATION_PROCESS=PUSH_MESSAGE",
                    x01: $v('P' + $v('pFlowStepId') + '_ID'),
                    x02: $v('P' + $v('pFlowStepId') + '_MESSAGE')
                },
                success: function (d) {
                    void (0);
                }
            })
            $('#P' + $v('pFlowStepId') + '_MESSAGE').val('');
        }
    },
	
	// Remove Recipients from chet
	removeFromMsg: (pRcp, pCnvId, pThis) => {
		apex.server.process('REMOVE_FROM_MSG_GROUP', {
			x01: pRcp,
			x02: pCnvId
		}, {
				type: "GET",
				dataType: "json",
				success: function (pData) {
					if (pData.STATUS == 'OK') {
						if (pThis) $(pThis).parent().remove();
                        else location.reload();
					} else {
						alert(apex.lang.getMessage("JS3"));
					}
				}
			});
	},	
	
	// Generate COnversation p331
	genConversation: (pCnvId) => {
		$(".uiConversation").remove();
		x = 0;
        window.chatState='resolved';
		
		apex.server.process('GENERATE_CONVERSATION', {
			x01: pCnvId
		}, {
				type: "GET",
				dataType: "html",
				success: (d) => {
					    $("#uiCvsContainer").html(d);
                        lx.msg.getMessage(pCnvId);
				}
			});
	},	
    // Instant Messaging
    getMessage: (pConversationId) => {
        if (window.chatState != 'pending' && x === 0) {
			//alert('1');
            apex.server.process('GET_MESSAGE', {
                x01: pConversationId
            }, {
                type: "GET",
                dataType: "html",
                success: (d) => {
                    if (x === 0) {
                        $("#message").html(d);
                        x = d.length; //defined in p40	
                        lx.msg.getMessage(pConversationId);
                    }
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    lx.topMenu.fetchInProgress = false;
                    console.log( errorThrown );
                }
            });
        }

        if (x != 0) {
			
			//alert('state 1 = '+ window.chatState + '> ' + pConversationId);
            vId = $('#message').find('#uiMessageTbl tr:first').attr('id').substring(4);

            var comet =
                $.ajax({
                    url: "wwv_flow.show",
                    dataType: "html",
                    traditional: true,
                    timeout: 30000,
                    cache: false,
                    type: "GET",
                    data: {
                        p_flow_id: $v("pFlowId"),
                        p_flow_step_id: $v("pFlowStepId"),
                        p_instance: $v("pInstance"),
                        p_request: "APPLICATION_PROCESS=APD_MESSAGE",
                        x01: pConversationId,
                        x02: vId
                    },
                    success: function (d) {
 
                        $('div#message div#msg-inbox table#uiMessageTbl tbody tr#MSGR' + vId).before(d);
                        var vMsg = $(d).find('.msg-text').text();
                        var vPrfl_href = $(d).find('.ui-prfl').attr('href');
                        var vPrfl_img = $(d).find('.ui-prfl-img').attr('src');
                        var vPrfl_fol = $(d).find('.ui-prfl-fol').text();
                        var vPrfl_com = $(d).find('.ui-prfl-com').text();

                        if (vPrfl_com.length > 0) {
                            if (vPrfl_com.length > 20) {
                                vPrfl_com = vPrfl_com.substring(0, 15) + '..'
                            }
                            vPrfl_name = vPrfl_fol + ' (' + vPrfl_com + ')';
                        } else
                            vPrfl_name = vPrfl_fol;
                        //alert(d);
                        if (window.isUserActive === 'hidden' && vMsg.length > 0) {
                            //notifyMe(vPrfl_name, vMsg.substring(0, 40) + '..', vPrfl_img);
                            $('#uiChatSound')[0].play();
                        }
						//alert('state = '+comet.state() + '> ' +pConversationId);
                        window.chatState = comet.state();
                        lx.msg.getMessage(pConversationId);
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    //alert(errorThrown);
                    if (errorThrown.length !== 0)
                    lx.msg.getMessage(pConversationId);
                });
        }
    },
    bc: new BroadcastChannel('chat'),
    pg: $v("pFlowStepId"),
    msgPageTime: null,
    chats: {},
    newChats: {},
    mobileBreakpoint: 640,
    originalTitle: null,
    emojiPickers: {},
    observers: {},
    freqInterval: null,
    freqRefreshExpire: new Date(),
    freqRefreshStatusExpire: new Date(),
    freqRefresh: (onload) => {
        if (onload){
            lx.msg.freqInterval = setInterval(function() {
                //console.log("Normal chats refresh");
                lx.msg.chatCheck();
            }, 30000);
        } else {
            lx.msg.freqRefreshExpire = new Date(new Date().getTime() + 1*60000);
            clearInterval(lx.msg.freqInterval);
            lx.msg.freqInterval = setInterval(function() {
                //console.log("Frequent chat refresh");
                lx.msg.chatCheck();
                if (new Date() > lx.msg.freqRefreshExpire) {
                    clearInterval(lx.msg.freqInterval);
                    lx.msg.freqRefreshExpire = new Date(new Date().getTime() + 1*60000);
                    lx.msg.freqInterval = setInterval(function() {
                        //console.log("Less Frequent chat refresh");
                        lx.msg.chatCheck();
                        if (new Date() > lx.msg.freqRefreshExpire) {
                            clearInterval(lx.msg.freqInterval);
                            lx.msg.freqInterval = setInterval(function() {
                                //console.log("Normal chats refresh");
                                lx.msg.chatCheck();
                            }, 30000);
                        }
                        }, 5000);
                }
            }, 2000);
        }
    },
    refreshFetch: false,
    refreshHold: false,
    full: false,
    soundNewMsg: new Audio('/i/lxprep/dist/audio/water_droplet.mp3'),
    //soundBuzz: new Audio('/i/lxprep/dist/audio/bell_ring.mp3'),
    attentionAdd: (pCnvId) => {
        lx.msg.soundNewMsg.play();
        $("#chat"+pCnvId).addClass("attention").click( function () {
            lx.msg.attentionRemove(this);
        });
        $("#Msg"+pCnvId).addClass("attention").click( function () {
            lx.msg.attentionRemove(this);
        });
        if (!lx.msg.originalTitle) lx.msg.originalTitle = document.title;
        document.title = lx.tran.get("NEW_MESSAGE")+'! 📫';
        // TODO OS Notification if tab is not focused (document.hidden / document.visibilityState = "visible" / document.hasFocus())
        // https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API
    },
    attentionRemove: (pThis) => {
        $(pThis).unbind().removeClass("attention");
        if ($(".chatSlot.attention").length == 0 && lx.msg.originalTitle) document.title = lx.msg.originalTitle;
    },
    topMenuRefresh: () => {
        if (lx.topMenu.opened == "M") lx.topMenu.refresh("M");
        else lx.topMenu.reset("M");
    },
    openEmoji: (pId) => {
        //if (lx.msg.emojiPickers[pId]) lx.msg.emojiPicker.destroy();
        //if (!lx.msg.emojiPickers[pId]) {
            lx.msg.emojiPickers[pId] = new FgEmojiPicker({
                trigger: ['#eb'+ pId],
                insertInto: document.querySelector('#chatTa'+ pId),
                removeOnSelection: true,
                closeButton: true,
                position: ['top', 'right'],
                dir: '/i/lxprep/dist/plugin/emojiPicker/'
            });
            //$("#eb"+pId).on("click", (e) => {lx.msg.emojiPickers[pId].functions.openEmojiSelector(e).bind(lx.msg.emojiPickers[pId]);});
        //}
        /*lx.msg.emojiPicker = new EmojiPicker({
            trigger: [
                {
                    selector: '#eb'+ pId,// #chat'+ d.id +' 
                    insertInto: ['#chat'+ pId +' textarea']
                }
            ],
            closeButton: true,
            specialButtons: '#02535B' // $c1
        });*/
    },
    chatAddMsgs: (id, msgs, newMsgs, att) => {
        const $cont = $("#chat"+id+' > .body > .cont');
        if (newMsgs) {
            for (let i = (msgs.length-1); i >= 0; i--) {
                const m = msgs[i];
                let image = lx.profile.genPic(m.img);
                if (m.plink) image = m.plink + image + '</a>';
                let html = '<div class="msg'+ (m.media ? ' media' : '') +'">'+
                            '<div class="img">'+ image +'</div>'+
                            '<div class="body">'+ 
                            '<div class="hdr">'+ m.name +' &bull; <span>'+ m.time +'</span></div>'+
                            '<div class="txt">'+ linkifyHtml(m.msg, {target: '_blank'}) +'</div>'+
                            '</div>'+
                        '</div>';
                $cont.prepend(html);
            }
            if (msgs.length > 0) {
                lx.msg.freqRefresh();
                if (att){
                    lx.msg.attentionAdd(id);
					$("#Msg"+ id + " .msgImages").append('<div class="chatBadge"></div>');
                }
            }
        } else {
            let lastId = 0, lMore = false;
            $("#chat"+ id +" .loadMore").remove();
            for (let i = 0; i < msgs.length; i++) {
                const m = msgs[i];
                let html;
                if (m.more){
                    //html = '<div class="loadMore" onclick="lx.msg.chatMore(\''+ id +'\');">Load more..</div>';
                    html = '<span class="loadMore u-Processing" role="alert"><span class="u-Processing-spinner"></span><span class="u-VisuallyHidden">Processing</span></span>'
                    lMore = true;
                } else {
                    let image = lx.profile.genPic(m.img);
                    if (m.plink) image = m.plink + image + '</a>';
                    html = '<div class="msg'+ (m.media ? ' media' : '') +'">'+
                            '<div class="img">'+ image +'</div>'+
                            '<div class="body">'+ 
                            '<div class="hdr">'+ m.name +' &bull; <span>'+ m.time +'</span></div>'+
                            '<div class="txt">'+ linkifyHtml(m.msg, {target: '_blank'}) +'</div>'+
                            '</div>'+
                        '</div>';
                    lastId = m.id;
                }
                $cont.append(html);
            }
            // set last message id for next more fetch
            if (lastId > 0){
                $("#chat"+id).attr('data-first', lastId);
            }
            // Load more observer
            if (lMore) {
                lx.msg.observers[id] = new IntersectionObserver(entries => {
                        if (entries[0].isIntersecting) {
                            lx.msg.observers[id].unobserve(entries[0].target);
                            lx.msg.chatMore(id);
                        }
                    },
                    {root: document.querySelector("#chat"+ id +" .cont")}
                );
                lx.msg.observers[id].observe( document.querySelector("#chat"+ id +" .loadMore") );
            }
        }
    },
    chatRender: (d) => {
        if ($("#chatDock").length == 0 && !lx.msg.full) $(".t-Body").append('<div id="chatDock" class="chatDock"></div>');
        if (document.body.clientWidth < lx.msg.mobileBreakpoint || lx.msg.full) {
            $("#chatDock .chatSlot").each( function (i) { lx.msg.chatClose($(this).attr("data-id"))});
            if (lx.msg.newChats[d.id]){
                lx.msg.newChats[d.id] = false;
                /*lx.topMenu.reduceBadge('M', 1);
                lx.topMenu.reset("M");*/
            }
        }
        if (d.unread) {
            lx.topMenu.reduceBadge('M', 1);
			$("#Msg"+ d.id + " .msgImages .chatBadge").hide();
            lx.topMenu.reset("M");
        }
        //lx.msg.chats[d.id] = d;
        //$("#chat"+d.id).remove();//lx.msg.chatClose(d.id);

        let lRecipients = "";
        let lGroupSubject = [];
        let lSubjectImgs = "";
        for (let i = 0; i < d.recipients.length; i++) {
            let r = d.recipients[i];
            lRecipients += '<div id="c'+ d.id +'r'+ r.id +'" class="recipient'+ (r.archived ? ' archived' : '') +'">'+ 
                            '<div class="msgImages"><div class="MsgImg1">'+ lx.profile.genPic(r.img) +'</div></div>'+
                            '<div class="subject">'+ r.name + r.statusDisp +' </div>'+
                            (d.creator ? ' <i class="msg-remove-icon fas fawe-times" style="cursor:pointer;" onclick="lx.msg.removeFromMsg('+ r.id +','+ d.id +', this);"></i>' : '')+
                            '</div>';
            if (i == 0) {
                if (d.recipients.length == 1) r.img.size = 'S';
                lSubjectImgs = '<div class="MsgImg1">'+ lx.profile.genPic(r.img) +'</div>';
            } else if (i == 1) {
                r.img.size = 'SS';
                lSubjectImgs += '<div class="MsgImg2">'+ lx.profile.genPic(r.img) +'</div>';
            }
            lGroupSubject.push( r.name.split(' ')[0] );
        }

        let html = '<div class="body">'
        +'<div class="hdr">' /*style="background-color:'+ d.profileColor +';">'*/
        + '<div class="msgImages">'+ lSubjectImgs +'</div>'
        + '<div class="subject">'+ d.subject + (d.recipients.length > 1 ? ' <div class="chatStatusTxt">'+ lGroupSubject.join(', ') +'</div>' : '') +'</div>'
        + '<div class="actions">'
        +  d.dd
        + lx.btn.gen({"fa":"far fawe-minus","js":"lx.msg.chatToggle(this);","class":"t-Button--noUI t-Button--noLabel minimize"})
        + lx.btn.gen({"fa":"far fawe-plus","js":"lx.msg.chatToggle(this);","class":"t-Button--noUI t-Button--noLabel maximize"})
        + lx.btn.gen({"fa":"far fawe-times","js":"lx.msg.chatClose("+ d.id +");","class":"t-Button--noUI t-Button--noLabel close"})
        + '</div>'
        +'</div>'
        +'<div class="recipient chatStsYou"><div class="msgImages"><div class="MsgImg1">'+ lx.profile.genPic(d.img) +'</div></div>'
        + '<div class="subject">'+ d.yourStatus +'</div>'+ d.yourDD +'</div>'
		/*+ '<div class="subActions">'+ d.yourDD +'</div>'*/
        +'<div class="recipients">'+ lRecipients +'</div>'
        +'<div class="cont"></div>'
        +'<div class="chatForm">'
        + '<textarea maxlength="4000" class="textarea apex-item-textarea" placeholder="Write a message" id="chatTa'+ d.id +'"></textarea>'
        + '<div class="controls">'+ 
            '<div class="t-Button emoji-button" id="eb'+ d.id +'" onclick="lx.msg.openEmoji('+ d.id +');">😄</div>'+
            (d.attachLbl ? lx.btn.gen({"id":"chatPostBtn","label":d.attachLbl,"fa":"far fawe-paperclip","js":d.attachLink}) : '') +
            lx.btn.gen({"label":d.postLbl,"fa":"far fawe-paper-plane","js":"lx.msg.chatPost("+ d.id +");","class":"t-Button--primary"}) +
           '</div>'
        +'</div>'
        +'</div>';

        html = '<div id="chat'+ d.id +'" class="chatSlot'+ (d.minimised ? ' minimised' : '') +'" data-id="'+ d.id +'" data-last="'+ d.lastMsgId +'">'+ html +'</div>';
        if ($("#chat"+d.id).length == 0) $("#chatDock").append(html);
        else $("#chat"+d.id).replaceWith(html);
        
        lx.msg.chatAddMsgs(d.id, d.msgs);
        
        /* Post on enter */
        $("#chat"+ d.id +' textarea').keypress(function (e) {
            if ($("#chatDock").hasClass("sendEnter") && e.keyCode == 13 && !e.shiftKey) {
                e.preventDefault();
                lx.msg.chatPost(d.id);
            }
        });
        if (d.chatSendEnter == 'Y') $("#chatDock").addClass("sendEnter");
        else $("#chatDock").removeClass("sendEnter");
        // emoji
        //$("#chat"+ d.id +' textarea').emojiarea();
        /*lx.msg.emojiPickers[d.id] = new EmojiPicker({
            trigger: [
                {
                    selector: '#eb'+ d.id,// #chat'+ d.id +' 
                    insertInto: ['#chat'+ d.id +' textarea']
                }
            ],
            closeButton: true,
            specialButtons: '#02535B' // $c1
        });*/
    },
    chatCheck: () => {
        let chats = [];
        let lastMsgs = [];
        let statusRefresh = 'N';

        if (lx.msg.refreshHold || lx.msg.refreshFetch) return;
        // collect all open chats data
        $("#chatDock .chatSlot").each(function() {
            chats.push( $(this).attr("data-id") );
            lastMsgs.push( $(this).attr("data-last") );
        });
        // check for status change
        if (new Date() > lx.msg.freqRefreshStatusExpire) {
            statusRefresh = 'Y';
            lx.msg.freqRefreshStatusExpire = new Date(new Date().getTime() + 1*30000);
        }

        let now = new Date();
        now.setMinutes(now.getMinutes() - 1);
        if (lx.msg.pg == 331 || lx.msg.msgPageTime == null || lx.msg.msgPageTime < now) {
            lx.msg.refreshFetch = true;
            apex.server.process('chatCheck', {  f01: chats, 
                                                f02: lastMsgs, 
                                                x01: (document.body.clientWidth < lx.msg.mobileBreakpoint || lx.msg.full ? 'Y' : 'N'),
                                                x02: statusRefresh
                                            }
                , {type:'GET',dataType:'json',success: (d) => {
                    lx.msg.refreshFetch = false;
                    let topRefresh = false;
                    if (!lx.msg.refreshHold) {
                        for (let i = 0; i < d.chats.length; i++) {
                            const c = d.chats[i];
                            lx.msg.chatAddMsgs(c.id, c.msgs, true, true);
                            if (c.msgs.length > 0) {
                                $("#chat"+ c.id).attr("data-last", c.msgs[0].id );
                                $("#chat"+ c.id +" > .body > .cont").stop().animate({ scrollTop: $("#chat"+ c.id +" > .body > .cont")[0].scrollHeight}, 1000);
                                topRefresh = true;
                            }
                        }
                    }
                    // open new chats
                    for (let i = 0; i < d.openChats.length; i++) {
                        const c = d.openChats[i];
                        topRefresh = true;
                        if ( (document.body.clientWidth < lx.msg.mobileBreakpoint || lx.msg.full) && $("#chatDock .chatSlot").length > 0){
                            if (!lx.msg.newChats[c.id]){
                                lx.msg.newChats[c.id] = true;
                                lx.topMenu.increaseBadge('M', 1);
                                lx.msg.soundNewMsg.play();
								$("#Msg"+ c.id + " .msgImages").append('<div class="chatBadge"></div>');
                            }
                        } else {
                            lx.topMenu.increaseBadge('M', 1);
                            lx.msg.chatRender(c);
                            lx.msg.attentionAdd(c.id);
							$("#Msg"+ c.id + " .msgImages").append('<div class="chatBadge"></div>');
                        }
                    }
                    // refresh open chat recipient statuses
                    if (statusRefresh == 'Y' && d.status){
                        // loop through chats
                        for (let i = 0; i < d.status.length; i++) {
                            const sts = d.status[i];
                            // update only single recipient chats
                            if (sts.recipients.length == 1){
                                let $cnvTitle = $("#chat"+sts.id+" .hdr>.subject");
                                $cnvTitle.find("span").text(" | "+ sts.recipients[0].status);
                                let $text = $cnvTitle.find(".chatStatusTxt");
                                if (!sts.recipients[0].text) {
									$text.remove();
								}
                                else if ($text.length == 0) {
									$cnvTitle.append('<div class="chatStatusTxt"><i class="far fawe-info-circle"></i> <span>'+ sts.recipients[0].text +'</span></div>');
								}
                                else  {
									$text.html('<div class="chatStatusTxt"><i class="far fawe-info-circle"></i> <span>'+ sts.recipients[0].text +'</span></div>');
								}
                            } else {
                                for (let j = 0; j < sts.recipients.length; j++) {
                                    const r = sts.recipients[j];
                                    const $r = $('#c'+ sts.id +'r'+ r.id);
                                    $r.find("span").text(" | "+ r.status);
                                    let $text = $r.find(".chatStatusTxt");
                                    if (!r.text) $text.remove();
                                    else if ($text.length == 0) $r.append('<div class="chatStatusTxt">'+ r.text +'</div>')
                                    else $text.text(r.text);
                                }
                            }
                        }
                    }
                    // refresh top menu
                    if (topRefresh) lx.msg.topMenuRefresh();
                    if (lx.msg.pg != 331) $("#chatDock").show();
                },
                error: function( jqXHR, textStatus, errorThrown ){
                    lx.msg.refreshFetch = false;
                }
            });
        }// else if (lx.msg.pg != 331 && lx.msg.msgPageTime > now) $("#chatDock").hide();

        if (lx.msg.pg == 331) lx.msg.bc.postMessage('p331');
    },
    chatMore: (pCnvId) => {
        lx.topMenu.removeClickListener();
        //lx.load.add();
		apex.server.process('chatMore', { x01: pCnvId, x02: $("#chat"+pCnvId).attr('data-first')}, {
				type: "GET",
				dataType: "json",
				success: (d) => { 
                    //lx.load.remove();
                    lx.msg.chatAddMsgs(pCnvId, d.msgs);
                }
            });
    },
    chatOpen: (pCnvId, pFull) => {
        lx.topMenu.removeClickListener();
        lx.load.add();
		apex.server.process('chatOpen', { x01: pCnvId}, {
				type: "GET",
				dataType: "json",
				success: (d) => { 
                    lx.load.remove();
                    if (pFull) {
                        $("#chatDock").remove();
                        $(".lxMsgContent").attr("id", "chatDock");
                        lx.msg.full = true;
                    }
                    lx.msg.chatRender(d);
                }
            });
    },
    chatsPageLoad: () => {
        lx.msg.bc.onmessage = event => { 
            console.log(event); 
            if (event.data=="check331" && lx.msg.pg == 331) lx.msg.bc.postMessage('p331'); 
            else if (event.data == "p331") {
                if (lx.msg.pg != 331) $("#chatDock").hide();
                lx.msg.msgPageTime = new Date();
            }
        }
        if (lx.msg.pg == 331) {
            lx.msg.bc.postMessage('p331');
            lx.msg.freqRefresh(true);
            return;
        } else if (lx.msg.pg == 101) return;
        else lx.msg.bc.postMessage('check331');

        setTimeout(function() {
            let now = new Date();
            now.setMinutes(now.getMinutes() - 1);
            if (lx.msg.pg == 331 || lx.msg.msgPageTime == null || lx.msg.msgPageTime < now )
                apex.server.process('chatsPageLoad', {}, {type:'GET',dataType:'json',success: (d) => {
                    for (let i = 0; i < d.unread.length; i++) {
                        lx.msg.newChats[d.unread[i]] = true;
                    }
                    for (let i = 0; i < d.chats.length; i++) {
                        const c = d.chats[i];
                        lx.msg.chatRender(c);
                    }
                    lx.msg.freqRefresh(true);
                }});
            else 
                setTimeout(function() {
                    lx.msg.chatsPageLoad();
                }, 30000);
        }, 100);
    },
    chatToggle: (pThis) => {
        $chat = $(pThis).closest('.chatSlot');
        $chat.toggleClass("minimised").removeClass("showRecipients");
        apex.server.process('chatMinimised', {x01: $chat.attr("data-id"), x02: ($chat.hasClass("minimised") ? 'Y' : 'N')}, {type:'POST'});
    },
    chatClose: (pCnvId) => {
        $("#chat"+pCnvId).remove();
        apex.server.process('chatClose', {x01:pCnvId}, {type:'POST'});
    },
    chatRecipients: (pCnvId) => {
        $("#chat"+ pCnvId ).toggleClass("showRecipients");
    },
    chatMedia: (pCnvId) => {
        $('#chat'+pCnvId).toggleClass("mediaOnly");
        /*apex.server.process('chatMedia', {x01: pCnvId}, {type: 'GET', dataType: 'json', success: (d) => {
            let html = '';
            for (let i = 0; i < d.files.length; i++) {
                const f = d.files[i];
                html += '<div class="mediaFile"><div class="img">'+ f.img +'</div><div class="info"><div>'+ f.date +'</div><div class="download">'+ f.download +'<div>'+ f.size +'</div></div></div></div>';
            }
            lx.dialog.open({id:"chatMedia", maxWidth: "600px", title: "Media", html: '<div id="chatMedia">'+ (html ? html : 'No media files') +"</div>"});
        }});*/
    },
    chatSendToggle: () => {
        $("#chatDock").toggleClass("sendEnter");
        apex.server.process('chatSendEnter', {x01: ($("#chatDock").hasClass("sendEnter") ? 'Y' : 'N') }, {type:'POST',dataType:'html'});
    },
    chatPost: (pCnvId, e) => {
        let lTxt = $("#chat"+ pCnvId +' textarea').val();
        $("#chat"+ pCnvId +' textarea').val("");
        let lastMsgId = $("#chat"+ pCnvId).attr("data-last");
        
        lx.msg.refreshHold = true;
        apex.server.process('chatAdd', { x01: pCnvId, x02: lTxt, x03: lastMsgId}, {type: 'POST', dataType: 'json', success: (d) => {
                if (d.success) {
                    lx.msg.refreshHold = false;
                    lx.msg.chatAddMsgs(pCnvId, d.msgs, true);
                    lx.msg.attentionRemove($("#chat"+ pCnvId)[0]);
                    //$("#chat"+ pCnvId).unbind().removeClass("attention");
                    if (d.msgs.length > 0) {
                        if (d.msgs[0].id) $("#chat"+ pCnvId).attr("data-last", d.msgs[0].id );
                        $("#chat"+ pCnvId +" > .body > .cont").stop().animate({ scrollTop: $("#chat"+ pCnvId +" > .body > .cont")[0].scrollHeight}, 1000);
                    }
                    // refresh top menu
                    lx.msg.topMenuRefresh();
                } else lx.info.msg(d.err);
            },
            error: function( jqXHR, textStatus, errorThrown ){
                lx.msg.refreshHold = false;
            }
        });
    },
    chatLeave: (pCnvId) => {
        apex.server.process('chatLeave', {x01:pCnvId}, {type:'POST', dataType: 'html', success: (d) => {
            lx.msg.chatClose();
            // refresh top menu
            lx.msg.topMenuRefresh();
        }});
    },
    chatArchive: (pCnvId, pArchive) => {
        apex.server.process('ARCHIVE_MESSAGE', {x01:pCnvId, x02: (pArchive?'A':'H')}, {type:'POST', dataType: 'html', success: (d) => {
            if (pArchive) lx.msg.chatClose(pCnvId);
            else lx.msg.chatOpen(pCnvId);
            // refresh top menu
            lx.msg.topMenuRefresh();
        }})
    },
    initEntityConversation: (pEtyId, pRecId) => {
        lx.load.add();
        apex.server.process("initEntityConversation", {
            x01: pEtyId,
            x02: pRecId
        }, {
            dataType: "json",
            success: function (d) {
                    lx.load.remove();
                    if (d.id) lx.msg.chatOpen(d.id);
                    else if (d.msg) lx.info.error(d.msg);
                }
            });
    }
}